var _rect, _rect2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#587E85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12.9998,
    width: 3.578,
    height: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.324 13.1288C21.286 13.1168 21.25 13.1038 21.21 13.0928C21.162 13.0818 21.114 13.0728 21.065 13.0648C20.875 13.0268 20.667 12.9998 20.423 12.9998C18.337 12.9998 17.014 14.5168 16.578 15.1028V12.9998H13V23.9998H16.578V17.9998C16.578 17.9998 19.282 14.2338 20.423 16.9998C20.423 19.4688 20.423 23.9998 20.423 23.9998H24V16.5768C24 14.9148 22.861 13.5298 21.324 13.1288Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.75,
    cy: 9.74988,
    r: 1.75,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLinkedin);
export default __webpack_public_path__ + "static/media/new_linkedin.5072362945ad05c8e5dda5c796573c36.svg";
export { ForwardRef as ReactComponent };